<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NVMz6v/tc-custom/9781555848552.jpg?1728353090863" alt="This image is the cover for the book Pig Island"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pig Island
      </h1>
      <p class="bookDescription body article font2">
        <b>A “profoundly creepy and creepily convincing thriller” of religious fanatics and hoax debunkers from the Edgar Award–winning author of <i>Hanging Hill</i> (<i>Publishers Weekly</i>, starred review)</b><br/>  <br/> Journalist Joe Oakes makes a living exposing supernatural hoaxes, but when he visits a secretive religious community on a remote Scottish island, everything he thought he knew is overturned.<br/>  <br/> Following the trail of a strange creature caught briefly on film, so deformed it can hardly be human, Oakes crosses a border of electrical fencing, toxin-filled oil drums, and pig skulls to infiltrate the territory of the groups’ isolated founder, Malachi Dove. Their confrontation, and its violent aftermath, is so catastrophic that it forces Oakes to question the nature of evil—and whether he might be responsible for the heinous crime about to unfold . . .<br/>  <br/> This latest entry from the acclaimed British author of the Jack Caffery novels “taps into the current fascination with all things supernatural and questions our assumptions about a number of subjects, from faith healing to cultish religious groups and society’s definition of evil” (Marilyn Stasio, <i>The New York Times Book Review</i>).<br/>  <br/> “[Hayder] remains one of our most adventurous, unpredictable and ambitious writers.” —<i>The Guardian</i><br/>  <br/> “Hayder offers both a riveting story and a nuanced, distinctly modern look at secrecy and publicity, belief and skepticism, normal and taboo, (in)sight and blindness.” —<i>Publishers Weekly</i>, starred review<br/>  <br/> “An adventurous, edgy, literate writer.” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mo Hayder
      </h2>
      
      <p class="authorDescription body article">Mo Hayder has worked as a filmmaker, Tokyo nightclub hostess, and English language teacher in Asia. She is also the author of <I>Birdman</I>; <I>The Treatment</I>; <I>The Devil of Nanking</I>, winner of the<I> Elle Magazine</I> crime fiction prize; <I>Pig Island</I>, shortlisted for the Barry Award for Best British Crime Novel; <I>Ritual</I>, shortlisted both for the CWA Ian Fleming Steel Dagger award and for the coveted Theakstons Old Peculier Crime Novel of the Year Award; <I>Skin</I>; and <I>Gone</I>; as well as the winner of the 2011 Crime Writers&#39; Association Dagger in the Library award for outstanding body of work. She lives in England.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a0b10ec8